export default __webpack_public_path__ + "static/media/Front-Maison-Maatouk.61a171d6.jpg";